import React from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { AiAccordion } from './components/AiAccordion';
import { useTopicContentSection } from './hooks/useTopicContentSection';

export const TopicContentSection: React.FC = () => {
	const {
		data: { description, name, onAccordionToggle, structuredData },
	} = useTopicContentSection();
	const { translate } = useI18n();

	if ((structuredData && !structuredData.length) || (!structuredData && !description)) {
		return null;
	}

	return (
		<div className="flex flex-col gap-6">
			{/* Only show description when structuredData is not available */}
			{!structuredData && description && (
				<AiAccordion
					content={description}
					dataQa="topic-accordion"
					onToggle={(expanded) => onAccordionToggle(expanded, 'topic_learn_more_expand')}
					title={translate('corgi.topic_page.page_heading.accordion_title', { name })}
				/>
			)}

			{structuredData?.map((item, index) => (
				<AiAccordion
					key={item.id}
					dataQa={`topic-structured-data-accordion-${index}`}
					content={item.content}
					onToggle={(expanded) => onAccordionToggle(expanded, `topic_structured_data_expand-${index}`)}
					title={item.title}
				/>
			))}
		</div>
	);
};
